import logo from "@/assets/crank-logo.png";

export const BrandLogo = ({ className = "w-6 h-6" }) => (
  <img src={logo} alt="Crank.live" className={`${className} object-contain`} data-testid="brand-logo" />
);

export default BrandLogo;
